module.exports = __webpack_public_path__ + "static/media/4.adf0115d.png";